<template>
  <div class="method">
    <IconComponent :name="icon" />
    <span class="method__title">{{ title }}</span>
    <span v-if="description" class="method__description">{{ description }}</span>
  </div>
</template>

<script>
import IconComponent from "components/IconComponent.vue";

export default {
  name: "CartWayComponent",
  components: { IconComponent },
  props: {
    title: String,
    icon: String,
    description: String,
  },
};
</script>

<style lang="stylus">
.method {
  background: var(--white);
  border: 1px solid var(--main-color-75)
  border-radius: var(--main_radius)
  padding 10px 11px 10px 13px
  height 68px
  display flex
  align-items center
  justify-content space-between
  gap 5px
  cursor pointer
  width 100%
  +below(420px) {
    height 50px
  }

  &--active {
    border: 2px solid var(--main-color-75)
    padding 10px
    padding-left 12px
  }

  .icon {
    width 20px
    height 20px
  }

  &__title {
    flex-grow 1
  }

  &__description {
    flex-shrink 0
    margin-left: auto;
    opacity: 0.3;
  }
}
</style>
